/**
 * Release kinds, matching ProductsRelease.type on the backend. "treatment" is
 * written by the treatment sheet when a flagged stage starts, so it is listed
 * in All Release but has no Add Release form.
 */
export type ReleaseType = "patient" | "employee" | "clinic" | "treatment";
export type AddReleaseType = Exclude<ReleaseType, "treatment">;

export const RELEASE_TYPES: ReleaseType[] = ["patient", "employee", "clinic", "treatment"];
export const ADD_RELEASE_TYPES: AddReleaseType[] = ["patient", "employee", "clinic"];

export const isReleaseType = (value: unknown): value is ReleaseType =>
  RELEASE_TYPES.includes(value as ReleaseType);

export const isAddReleaseType = (value: unknown): value is AddReleaseType =>
  ADD_RELEASE_TYPES.includes(value as AddReleaseType);

/** Releases with no price or payment. */
export const isUnpricedRelease = (type: unknown) => type === "clinic" || type === "treatment";

/** One manual line picked in ReleaseProductModal. */
export interface ReleaseLine {
  productId: string;
  productName: string;
  scale: string;
  unitPrice: number;
  quantity: number;
  total: number;
  discount: number;
  netTotal: number;
  availableQuantity: number;
}

/** Bill total for priced lines: line discounts count. Mirrors the backend. */
export const linesTotal = (lines: ReleaseLine[]) =>
  lines.reduce((sum, line) => sum + (Number(line.netTotal) || 0), 0);

export const staffName = (employee?: { firstName?: string; lastName?: string } | null) =>
  [employee?.firstName, employee?.lastName].filter(Boolean).join(" ");
